import React from 'react';
import { motion, useInView } from 'framer-motion';

const About = () => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section className="section py-16 sm:py-20 md:py-24 bg-white" ref={ref}>
      <div className="container">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Photo */}
          <motion.div
            className="order-2 md:order-1"
            initial={{ x: -100, opacity: 0 }}
            animate={isInView ? { x: 0, opacity: 1 } : {}}
            transition={{ duration: 0.8 }}
          >
            <div className="aspect-square bg-gradient-to-br from-gray-200 to-gray-300 rounded-2xl shadow-2xl relative overflow-hidden">
              <img
                src="https://cloud-1de12d.becdn.net/media/original/7debecdc19075ad5ee3d530984887251.jpg"
                alt="Cam Go Crazy"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            className="order-1 md:order-2"
            initial={{ x: 100, opacity: 0 }}
            animate={isInView ? { x: 0, opacity: 1 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 text-gray-900">
              The Story Behind the Mic
            </h2>
            <div className="prose prose-base sm:prose-lg text-gray-700 mb-6 sm:mb-8">
              <p className="mb-4 sm:mb-6">
                Born in Oakland. Built through struggle.
              </p>
              <p className="mb-4 sm:mb-6">
                Cam Go Crazy started Boss At Heart to speak life into pain — turning struggles into strength and purpose.
              </p>
              <p className="mb-4 sm:mb-6">
                This show isn't about perfection. It's about perspective. Real voices. Real emotion. Real growth.
              </p>
              <p>
                Because when you lead with heart, everything changes — your mindset, your hustle, your story.
              </p>
            </div>

            {/* Pull Quote */}
            <motion.blockquote
              className="text-xl sm:text-2xl md:text-3xl font-bold text-red-500 italic border-l-4 border-red-500 pl-4 sm:pl-6 py-3 sm:py-4"
              initial={{ y: 30, opacity: 0 }}
              animate={isInView ? { y: 0, opacity: 1 } : {}}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              "Boss isn't a title — it's a transformation."
            </motion.blockquote>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;